export const bookingStatusDecode = (status) => {
    switch (status.toString()) {
        case '0':
            return ['Looking for Courier','status-inprogress']
        case '1':
            return ['Matched with a Courier','status-inprogress']
        case '2':
            return ['Courier Cancelled','status-red']
        case '3':
            return ['Expired','status-red']
        case '4':
            return ['Rider Cancelled','status-red']
        case '5':
            return ['Delivered','status']
        case '6':
            return ['Delivered','status']
        case '7':
            return ['Delivered','status']
        case '8':
            return ['Courier Declined','status-red']
        case '9':
            return ['Sender Declined','status-red']
        case '10':
            return ['No Match Found','status-red']
        case '11':
            return ['Taxi Not Found','status-red']
        case '12':
            return ['Trip No Show','status-red']
        case '13':
            return ['Courier In Transit towards 1st Stop','status-inprogress']
        case '14':
            return ['Driver Cancelled Before Trip','status-red']
        case '15':
            return ['Rider Cancelled Before Trip','status-red']
        case '16':
            return ['Rider Cancelled Post Trip','status-red']
        case '17':
            return ['Driver Cancelled Post Trip','status-red']
        case '18':
            return ['Courier Arrived','status-inprogress']
        case '19':
            return ['Trip Replaced','status-inprogress']
        case '20':
            return ['Pending Completion','status-inprogress']
        case '21':
            return ['Courier is On The Way','status-inprogress']
        case '22':
            return ['Courier Arrived at Drop Off','status-inprogress']
        case '31':
            return ['Delivering to 2nd Stop','status-inprogress']
        case '32':
            return ['Delivering to 3rd Stop','status-inprogress']
        case '33':
            return ['Delivering to 4th Stop','status-inprogress']
        case '34':
            return ['Delivering to 5th Stop','status-inprogress']
        case '35':
            return ['Delivering to 6th Stop','status-inprogress']
        case '36':
            return ['Delivering to 7th Stop','status-inprogress']
        case '37':
            return ['Delivering to 8th Stop','status-inprogress']
        case '38':
            return ['Delivering to 9th Stop','status-inprogress']
        case '39':
            return ['Delivering to 10th Stop','status-inprogress']
        case '40':
            return ['Delivered','status']
        default :
            return ['Delivering','status-inprogress']
    }
}